export default class extends Controller {
  static targets = ["title", "templateSelect"];

  connect() {
    App.DynamicSelect.initEl(this.templateSelectTarget);
    App.DynamicSelect.onChange(this.templateSelectTarget, this.addTemplate.bind(this));
  }

  addTemplate(event) {
    event && event.preventDefault();
    this.title = this.templateTitle;
  }

  //
  // GETTERS AND SETTERS
  //

  set title(val) {
    if (this.hasTitleTarget && !this.titleTarget.value) {
      this.titleTarget.value = val;
    }
  }

  get templateTitle() {
    return App.DynamicSelect.getSelectedOptionText(this.templateSelectTarget);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/templates/template-select-in-form-controller.js